import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useLayout } from '@/app/store/layout.store';

import { useTimerControls, useTimerTick } from '@/features/timetracking';
import { AppShell } from '@/shared/ui/templates/AppShell';
import { Sidebar } from '@/widgets/Sidebar';
import { Topbar } from '@/widgets/Topbar';

/** Operational shell for tenant users. Owns the timer sync + 1 s tick. */
export function AppLayout() {
  useTimerControls();
  useTimerTick();
  const { sidebarOpen, setSidebarOpen } = useLayout();
  const { pathname } = useLocation();
  useEffect(() => setSidebarOpen(false), [pathname, setSidebarOpen]);
  return <AppShell sidebarOpen={sidebarOpen} onSidebarClose={() => setSidebarOpen(false)} sidebar={<Sidebar />} topbar={<Topbar />} content={<Outlet />} />;
}
